/*global scheduler*/
import React, { Component } from "react";
import PropTypes from "prop-types";

import 'dhtmlx-scheduler/codebase/dhtmlxscheduler.css';

if (typeof window !== `undefined`) {
  require('dhtmlx-scheduler')
  require ('dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_agenda_view');
  require ('dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_year_view');

}


export default class Index extends Component {
  componentDidMount() {
    if(scheduler) {
      const { events } = this.props;
      const agendaStart = events[0] && events[0].start_date;
      const agendaEnd = events[events.length - 1] && events[events.length - 1].end_date;
      if (agendaStart && agendaEnd) {
        scheduler.config.agenda_start = new Date(agendaStart);
        // scheduler.config.agenda_end = new Date(agendaEnd);
      }
      //scheduler.config.fix_tab_position = false;
      scheduler.config.readonly = true;
      scheduler.init('scheduler_here', new Date(), "agenda");
      scheduler.parse(events, "json");
    }
  }


  render() {
    return (
        <div id="scheduler_here" className="dhx_cal_container" style={{width:'100%',height:'100%'}}>
          <div className="dhx_cal_navline is-hidden-mobile">
            <div className="dhx_cal_prev_button">&nbsp;</div>
            <div className="dhx_cal_next_button">&nbsp;</div>
            <div className="dhx_cal_today_button"/>
            <div className="dhx_cal_date"/>

            <div className="dhx_cal_tab" name="agenda_tab" style={{left:224}}/>
            <div className="dhx_cal_tab" name="week_tab" style={{left:164}}/>
            <div className="dhx_cal_tab" name="month_tab" style={{left:104}}/>
            <div className="dhx_cal_tab" name="year_tab" style={{left:44}}/>
          </div>
          <div className="dhx_cal_header"/>
          <div className="dhx_cal_data"/>
        </div>
    );
  }
}

Index.propTypes = {
  events:PropTypes.array
};
Index.defaultProps = {
  events:[]
};
